import React, { PropTypes, Component } from 'react';
import Portal from 'components/Portal';
import { Styles } from 'material-ui';
import * as Colors from 'components/Material/Styles/Colors';
import { findDOMNode } from 'react-dom';

let { Spacing } = Styles;

let styles = {
  root: {
    position: 'absolute',
    // transform: 'translate3d(0,0,0)',
    zIndex: 2
  },
  overlay: {
    position: 'fixed',
    left: '-100%',
    top: 0,
    width: '100%',
    height: '100%',
    opacity: 1,
    willChange: 'opacity',
    // transform: 'translate3d(0,0,0)',
    transition:
      'left 0ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 400ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    backgroundColor: 'rgba(0, 0, 0, 0.541176)'
  },
  overlayOpen: {
    left: 0
  },
  panel: {
    position: 'fixed',
    // transform: 'translate3d(0,0,0)',
    top: 0,
    bottom: 0,
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    boxShadow:
      'rgba(0, 0, 0, 0.156863) 0px 3px 10px, rgba(0, 0, 0, 0.227451) 0px 3px 10px'
  },
  panelOpen: {
    left: 0
  }
};

export default class SlidingPanel extends Component {
  static propTypes = {
    overlay: PropTypes.bool,
    width: PropTypes.number
  };

  static defaultProps = {
    overlay: true,
    width: 4
  };

  state = {
    open: this.props.initialOpen
  };

  open(force = false) {
    if (!this.state.open) {
      this.setState({ open: true });
      if (this.props.onOpen) {
        this.props.onOpen();
      }
    } else if (force) {
      if (this.props.onOpen) {
        this.props.onOpen();
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.initialOpen && !this.state.open) {
      this.open();
    } else if (!nextProps.initialOpen && this.state.open) {
      this.close();
    }
  }

  getStyle() {
    let style = Object.assign({}, styles.root, this.props.style);
    if (this.props.zIndex) {
      style.zIndex = this.props.zIndex;
    }
    return style;
  }

  close() {
    if (this.state.open) {
      this.setState({ open: false });
      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }

  toggle() {
    if (this.state.open) {
      this.close();
    } else {
      this.open();
    }
  }

  handleOutsideMouseClick(e) {
    if (isNodeInRoot(e.target, findDOMNode(this.refs.panel))) {
      return;
    }
    this.close();
  }

  closeOverlay(e) {
    const { closeOnRequestClose, onRequestClose } = this.props;
    onRequestClose && onRequestClose();
    e.stopPropagation();
    e.preventDefault();
    if (closeOnRequestClose) {
      this.close();
    }
  }

  handleKeydown(e) {
    if (e.keyCode === 27) {
      this.close();
    }
  }

  createPanel(open) {
    let children;
    if (open) {
      children = this.props.children;
    }
    return (
      <div ref="panel" style={this.getPanelStyle(open)}>
        {children}
      </div>
    );
  }

  createOverlay(open) {
    return (
      <div
        onTouchTap={this.closeOverlay.bind(this)}
        style={this.getOverlayStyle(open)}
      />
    );
  }

  getPanelStyle(open) {
    return Object.assign(
      {
        backgroundColor: this.props.backgroundColor || Colors.Colors.bondiBlue,
        left: -Spacing.desktopKeylineIncrement * this.props.width - 10,
        width: Spacing.desktopKeylineIncrement * this.props.width
      },
      styles.panel,
      open ? styles.panelOpen : {}
    );
  }

  getOverlayStyle(open) {
    return Object.assign({}, styles.overlay, open ? styles.overlayOpen : {});
  }

  render() {
    let overlay, panel;
    let { open } = this.state;
    if (this.props.overlay) {
      overlay = this.createOverlay(open);
    }
    panel = this.createPanel(open);
    return (
      <Portal style={this.getStyle()}>
        {overlay}
        {panel}
      </Portal>
    );
  }
}

function isNodeInRoot(node, root) {
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/js/components/SlidingPanel.js